import { Injectable } from '@angular/core';

@Injectable()
export class AudioTrackStoreService {
    private _trackUrl: string;

    get trackUrl() {
        return this._trackUrl;
    }

    set trackUrl(value: string) {
        this._trackUrl = value;
    }
}
